import { Card } from '@parrot-software/design-system';
import { cn } from '@parrot-software/utils';

import { ParrotLogo } from '@experimental-components/IconsComponents/ParrotLogo';
import { PRIVACY_NOTICE } from '../../application/constants/privacyNotice';
import { PrivacyNoticeBlocks, PrivacyNoticeText } from '../components/PrivacyNoticeContent';

/** Column blocks of the document, in the order they are laid out. */
const SECTION_GROUPS = Array.from(new Set(PRIVACY_NOTICE.sections.map((section) => section.group)));

/**
 * Aviso de Privacidad Integral — route `/legal/terms`, public.
 *
 * The document is laid out as a series of two-column blocks that collapse to one below `md`, so a
 * phone reads it straight down. Section text is justified, as the document is set.
 */
export const PrivacyNotice = () => (
  <main className="min-h-screen bg-muted px-4 pb-24 pt-12 font-sans" lang="es">
    <div className="mx-auto max-w-[960px]">
      <Card className="p-6 md:p-12 lg:p-[72px]">
        <ParrotLogo aria-hidden className="mb-10 h-10 md:h-12" />

        <p className="mb-7 hyphens-auto text-justify text-[15px] font-semibold leading-relaxed text-foreground">
          <PrivacyNoticeText value={PRIVACY_NOTICE.preamble} />
        </p>

        <h1 className="mb-7 text-center text-3xl font-bold leading-tight tracking-tight text-primary md:text-[40px]">
          {PRIVACY_NOTICE.title}
        </h1>

        <p className="mb-3.5 hyphens-auto text-justify text-[15px] leading-relaxed text-foreground">
          <PrivacyNoticeText value={PRIVACY_NOTICE.lead} />
        </p>

        <PrivacyNoticeBlocks blocks={PRIVACY_NOTICE.intro} />

        <div aria-hidden className="my-9 h-px w-full bg-border" />

        {SECTION_GROUPS.map((group, groupIndex) => (
          <div
            className={cn('mb-10 last:mb-0 md:columns-2 md:gap-12 md:[column-rule:1px_solid_var(--border)]', {
              'border-t border-border pt-10': groupIndex > 0,
            })}
            key={group}
          >
            {PRIVACY_NOTICE.sections
              .filter((section) => section.group === group)
              .map((section) => (
                <section className="mt-7 first:mt-0" key={section.id}>
                  <h2 className="mb-3 text-lg font-semibold leading-snug tracking-tight text-primary break-after-avoid">
                    {section.title}
                  </h2>
                  <PrivacyNoticeBlocks blocks={section.blocks} />
                </section>
              ))}
          </div>
        ))}
      </Card>
    </div>
  </main>
);
